import LocaleStrings from "Languages";

export default function () {
  return [
    {
      iconName: "proposalwizard",
      section: "proposal",
      title: LocaleStrings.proposal_submenu_title1,
      description: LocaleStrings.proposal_submenu_description1,
    },
    {
      iconName: "proposaldashboard",
      section: "proposal",
      title: LocaleStrings.proposal_submenu_title2,
      description: LocaleStrings.proposal_submenu_description2,
    },
    {
      iconName: "proposalresponses",
      section: "proposal",
      title: LocaleStrings.proposal_submenu_title3,
      description: LocaleStrings.proposal_submenu_description3,
    },
    // {iconName:'proposalform', section:'proposal', title:LocaleStrings.proposal_submenu_title4, description:LocaleStrings.proposal_submenu_description4},
    {
      iconName: "proposalreveiwer",
      section: "proposal",
      title: LocaleStrings.proposal_submenu_title5,
      description: LocaleStrings.proposal_submenu_description5,
    },
  ];
}
